import logIt from '../../logIt';
import Browser from './hooks/Browser';
import ChatFlowEnableFlag from './hooks/ChatFlowEnableFlag';
import setPlaceholder from './hooks/setPlaceholder';

const Utils = {

    checkDateValue(date) {
        return date && !(new Date(date) == 'Invalid Date') && !isNaN(new Date(date));
    },
    tryParseJSON(jsonString) {
        try {
            const o = JSON.parse(jsonString);
            // Handle non-exception-throwing cases:
            // Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
            // but... JSON.parse(null) returns null, and typeof null === "object",
            // so we must check for that, too. Thankfully, null is falsey, so this suffices:
            if (o && typeof o === 'object') {
                return o;
            }
        } catch (e) { }
        return false;
    },
    disableElement(element, options) {
        if (!element) return;
        const el = element;

        const settings = {
            recursively: true,
            applyGrayBackground: false,
            ...options,
        };
        // These are the defaults.

        if (settings.applyGrayBackground) {
            el.classList.add('apexchat_disabled_element');
        }
        el.disabled = true;
        el.style.pointerEvents = 'none';
        if (settings.recursively && el.children) {
            for (let item of el.children) {
                Utils.disableElement(item, { recursively: true });
            }
        }
        return el;
    },
    enableElement(element, recursively) {
        if (!element) return;
        const el = element;
        el.disabled = false;
        el.style?.pointerEvents = 'auto';
        el.classList?.remove('apexchat_disabled_element');
        if (recursively && el.children) {
            for (let item of el.children) {
                Utils.enableElement(item, true);
            }
        }
        return el; // to allow method chaining
    },

    // call this method with proper context object; i.e. me
    // USAGE: ApexChat.Utils.enableTypingInput.bind2(me)('<inputContainerSelector>','<instruction>');

    preventTyping(element) {
        // prevent user to type anything.
        // as for mobile browser, only keyup event works for on screen keyboard so we used keyup event to prevent typing
        element.eventFunctions = element.eventFunctions || [];
        const keyupFunction = (e) => {
            element.value = '';
        }
        element.eventFunctions.push(keyupFunction)
        element.addEventListener('keyup', keyupFunction);
        return element;
    },
    removeEvent(element, eventName) {
        var events = element.eventFunctions;
        if (!events) {
            return;
        }
        element.eventFunctions.forEach(function (listener) {
            element.removeEventListener(eventName, listener);
        });
    },
    allowTyping(element) {
        // allow user to type anything.
        // reverting its functionality to normal keyup
        this.removeEvent(element, 'keyup')

        // Manually trigger the keyup event on the cloned element
        var event = new Event('keyup');
        element.dispatchEvent(event);
        logIt('Allow typing called');
        return element;
    },
    // a utility service class which can keep an array (of json type or primitive data types) in the session storage and offer methods to add items
    // or check existance based on some property matching (optionally)

    removeHttpProtocols(url) {
        return url.replace('http:', '').replace('https:', '');
    }
};
export default Utils